import React, {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from 'react';
import {useCompleteLocation} from './react-router';

const LocationContext = createContext({
  pathname: '/',
  search: '',
  hash: '',
} as unknown as Omit<ReturnType<typeof useCompleteLocation>, 'state' | 'key'>);

export const useLocation = () => useContext(LocationContext);

export const LocationProvider: FC<PropsWithChildren> = ({children}) => {
  const {pathname, search, hash} = useCompleteLocation();
  const memoizedLocation = useMemo(
    () => ({pathname, search, hash}),
    [hash, search, pathname],
  );
  return (
    <LocationContext.Provider value={memoizedLocation}>
      {children}
    </LocationContext.Provider>
  );
};

const LocationStateContext = createContext<any>(undefined);

export const useLocationState = <T extends unknown>() =>
  useContext<T | undefined>(LocationStateContext);

export const LocationStateProvider: FC<PropsWithChildren> = ({children}) => {
  const {state} = useCompleteLocation();
  return (
    <LocationStateContext.Provider value={state}>
      {children}
    </LocationStateContext.Provider>
  );
};
